import { z } from 'zod'

import { MembershipLevelValue } from '../constants/membership'
import { GenderType } from '../constants/gender'
import { InventoryType } from '../constants/inventory'
import { dbEntitySchema } from './system'

export const AttendeeSchema = dbEntitySchema.extend({
  firstName: z.string(),
  name: z.string(),
  title: z.string(),
  imageUrl: z.string(),
  user: z.string(),
  event: z.string().nullable(),
  venue: z.string(),
  date: z.date(),
  inventoryType: z.nativeEnum(InventoryType),
  membershipLevel: z.nativeEnum(MembershipLevelValue),
  gender: z.nativeEnum(GenderType),
  lastAttendeeCount: z.number().default(0),
  currentAttendeeCount: z.number().default(0),
})
